/* script */
//
//
//
//
//
//
//
//
//
//
//

// Components
import Badge from 'shared/ui/components/Badge.vue';

/**
 * This component shows the modules that the specific template has installed.
 * It differentiates between paid and unpaid modules
 *
 * @vue-prop {Object[]} packages the list of packages to display
 *
 * @category ui.components
 * @exports TemplateModules
 */
const __vue_script__ = {
    name: 'TemplateModules',

    components: { Badge },

    props: {
        packages: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            NR_MODULES_TO_SHOW: 5,
            limit: true,
            modules: [],
        };
    },

    computed: {
        /**
         * @returns {Array} the modules to be rendered
         */
        showModules() {
            if (this.limit) {
                return this.modules.slice(0, this.NR_MODULES_TO_SHOW);
            }
            return this.modules;
        },
    },

    mounted() {
        this.modules = [...this.packages].sort((a, b) => (b.paid) - (a.paid) || a.name.localeCompare(b.name));
    },
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body"},[_vm._l((_vm.showModules),function(module){return _c('div',{staticClass:"module"},[(module.paid)?_c('span',{staticClass:"opposite"},[_c('badge',{staticClass:"warn"},[_vm._v(_vm._s(_vm.$t('marketplace.paid_module')))])],1):_vm._e(),_c('span',[_vm._v(_vm._s(module.title || module.name))])])}),(_vm.limit && _vm.modules.length > _vm.NR_MODULES_TO_SHOW)?_c('a',{attrs:{"href":""},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.limit=false}}},[_vm._v(_vm._s(_vm.$t('marketplace.see_more')))]):_vm._e()],2)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "TemplateModules.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__